import * as React from 'react';

import { DataTable, Table } from '../../components/common';
import { TextInput } from '../../components/forms';
import { Button, IconButton } from '../../components/buttons';
import { IconArrowRight } from '../../components/icons';

interface Props {
	customers: UserDetails[];
	history: any;
	searchterm: string;
	onSearch: (e: any) => void;
	download: () => void;
}
const MissingBeneficiaryFormsList: React.StatelessComponent<Props> = props => {
	return (
		<div className="content-set">
			<div className="table-options">
				<TextInput
					name="search"
					placeholder="Search"
					value={props.searchterm}
					onChange={props.onSearch}
					className="m-0 table-search"
				/>
				{props.customers.length > 0 &&
					<div className="table-options">
						<div className="btn-group table-filters">
							<div className="table-filter">
								<Button
									className="btn-outline-primary"
									onClick={props.download}
								>
									<span className="align-middle mx-2">Download</span>
								</Button>
							</div>
						</div>
					</div>
				}
			</div>
			<DataTable
				TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
				columns={[
					{
						accessor: 'id',
						show: false
					},
					{
						Header: 'Full Name',
						accessor: 'fullName'
					},
					{
						Header: 'Email',
						accessor: 'email'
					},
					{
						Header: 'Actions',
						className: 'p-0 td-actions',
						width: 100,
						Cell: (rowInfo: any) => (
							<IconButton
								title="Edit customer"
								className="btn-icon-secondary btn-icon-td"
								onClick={(e: any) => {
									e.stopPropagation(); // Prevent onClick conflict with tr onclick
									props.history.push(`/admin/customers/${rowInfo.row.id}`);
								}}
							>
								<IconArrowRight />
							</IconButton>
						)
					}
				]}
				data={props.customers}
				getTrProps={(state: any, rowInfo: any, column: any) => {
					return {
						className: 'tr interactive',
						onClick: () => {
							props.history.push(`/admin/customers/${rowInfo.row.id}`);
						}
					};
				}}
				noDataText="No customers found"
			/>
		</div>
	);
};
export default MissingBeneficiaryFormsList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/reports/MissingBeneficiaryFormsList.tsx